<script setup>
import {ref} from "vue"

const nodeLayeringOptions = ["NETWORK_SIMPLEX", "LONGEST_PATH", "INTERACTIVE"]
const nodePlacementOptions = ["SIMPLE", "BRANDES_KOEPF", "LINEAR_SEGMENTS", "INTERACTIVE"]

const nodeLayeringModel = ref("NETWORK_SIMPLEX")
const nodePlacementModel = ref("SIMPLE")
const fullHierarchyModel = ref(false)
const layerSpacingModel = ref(0.8)

const emit = defineEmits(['on-layout-event'])

const onLayoutClick = () => {
    emit('on-layout-event', {
        layering: nodeLayeringModel.value,
        hierarchy: fullHierarchyModel.value,
        placement: nodePlacementModel.value,
        inLayerSpacing: Number(layerSpacingModel.value)
    })
}

</script>

<template>
    <div class="text-center">
        <v-menu
            :close-on-content-click="false"
            offset-x
        >
            <template v-slot:activator="{ on, attrs }">
                <div class="d-flex align-center justify-center flex-column">
                    <v-btn color="info" icon large v-bind="attrs" v-on="on">
                        <v-icon style="font-size: 24px">
                            mdi-source-branch-refresh
                        </v-icon>
                    </v-btn>
                    <div class="caption mt-n2" style="font-size: 0.70rem !important">
                        LAYOUT
                    </div>
                </div>
            </template>
            <v-list>
                <v-subheader class="ml-1" style="height: 24px">Layout options</v-subheader>
                <v-divider class="mb-6"/>
                <v-list-item>
                    <v-select
                        v-model="nodeLayeringModel"
                        :items="nodeLayeringOptions"
                        dense
                        label="Node Layering"
                        style="width: 210px"
                    ></v-select>
                </v-list-item>
                <v-list-item>
                    <v-select
                        v-model="nodePlacementModel"
                        :items="nodePlacementOptions"
                        dense
                        label="Node Placement"
                        style="width: 210px"
                    ></v-select>
                </v-list-item>
                <v-list-item>
                    <v-text-field
                        v-model="layerSpacingModel"
                        dense
                        label="Layer Spacing Factor"
                        style="width: 210px"
                    ></v-text-field>
                </v-list-item>
                <v-list-item>
                    <v-checkbox
                        v-model="fullHierarchyModel"
                        color="info"
                        dense
                        label="Full Hierarchy"
                    ></v-checkbox>
                </v-list-item>
                <v-list-item>
                    <v-btn block color="info" outlined rounded @click="onLayoutClick">
                        <v-icon
                            color="info"
                            left>
                            mdi-source-branch-refresh
                        </v-icon>
                        Layout
                    </v-btn>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>